import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

import { useTranslate } from 'src/locales';
import { hideDialog } from 'src/state/ui/actions';
import { useSelector, useDispatch, type RootState } from 'src/state';
import { getShowDialog, getFolderDialogContext } from 'src/state/ui/selectors';

import { FolderForm } from './folder-form';

// ----------------------------------------------------------------------

type FolderDialogProps = {
  onSuccess?: () => Promise<void> | void;
};

export function FolderDialog({ onSuccess }: FolderDialogProps) {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const showDialog = useSelector((state: RootState) => getShowDialog(state, 'folder'));
  const context = useSelector(getFolderDialogContext);

  const folderId = context?.folderId;
  const isEditMode = Boolean(folderId);

  const handleClose = () => {
    dispatch(hideDialog('folder'));
  };

  const handleSuccess = async () => {
    if (onSuccess) {
      await onSuccess();
    }
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={showDialog}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            overflow: 'visible',
          },
        },
      }}
    >
      <DialogTitle>{isEditMode ? t('Edit folder') : t('Create folder')}</DialogTitle>
      <FolderForm folderId={folderId} onClose={handleClose} onSuccess={handleSuccess} />
    </Dialog>
  );
}
